/**
 * @file iam 鉴权
 * @author zhouqiqi01@baidu.com
*/
import {getCookie} from './helper';
import axios from 'axios';
import Link from './link';

const http = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        csrfToken: getCookie('bce-user-info').replace(/"/g, '') // 获取cookie中的bce-user-info
    },
    baseURL: Link.host,
    withCredentials: true
});

const client = {
    // 查询IAM鉴权状态
    getIamRoleQuery(param, options = {}) {
        return http.post('/api/iam/sts/role/query', param, options);
    },
    // 在IAM中激活产品
    getIamRoleActive(param, options = {}) {
        return http.post('/api/iam/sts/role/activate', param, options);
    },
};

// iam 鉴权
export const getIamRoleCheck = () => {
    client.getIamRoleQuery({roleName: 'BceServiceRole_CBS'}).then(({data}) => {
        if (!data.result && data.success) {
            let isOnline = /(market|cloud|qifu)\.baidu\.com/.test(window.location.hostname);
            client.getIamRoleActive({
                roleName: 'BceServiceRole_CBS',
                accountId: getCookie('accountId'),
                policyId: isOnline ? '63291ad7868146b0b0c89ec187a03399' : '752fd7ad061e41c8859917721b243a39',
                serviceId: isOnline ? '9fb243cc70114a83a9a0e9f0d3b7d492' : '17fe71516322409bbc468ca64e7e5cbc'
            });
        }
    });
};
